export var FeedReferenceTypeApi;
(function (FeedReferenceTypeApi) {
    FeedReferenceTypeApi["POST"] = "post";
    FeedReferenceTypeApi["PROJECT_CHECK_IN_POST"] = "project_check_in_post";
})(FeedReferenceTypeApi || (FeedReferenceTypeApi = {}));
export var FeedContextTypeApi;
(function (FeedContextTypeApi) {
    FeedContextTypeApi["GROUP"] = "group";
    FeedContextTypeApi["CONTEST"] = "contest";
})(FeedContextTypeApi || (FeedContextTypeApi = {}));
export var FeedItemsOrderApi;
(function (FeedItemsOrderApi) {
    FeedItemsOrderApi["ID_DESC"] = "id_desc";
    FeedItemsOrderApi["UPDATED_DESC"] = "updated_desc";
    FeedItemsOrderApi["UPDATED_ASC"] = "updated_asc";
    FeedItemsOrderApi["CREATED_DESC"] = "created_desc";
    FeedItemsOrderApi["CREATED_ASC"] = "created_asc";
})(FeedItemsOrderApi || (FeedItemsOrderApi = {}));
export var FeedUserStateUpdateActionApi;
(function (FeedUserStateUpdateActionApi) {
    FeedUserStateUpdateActionApi["READ"] = "read";
})(FeedUserStateUpdateActionApi || (FeedUserStateUpdateActionApi = {}));
export var FeedItemActionApi;
(function (FeedItemActionApi) {
    FeedItemActionApi["FEED_ITEM_DELETE"] = "feed_item_delete";
})(FeedItemActionApi || (FeedItemActionApi = {}));
export var FeedItemActionDetailApi;
(function (FeedItemActionDetailApi) {
    FeedItemActionDetailApi["REMOVE_REASON"] = "remove_reason";
})(FeedItemActionDetailApi || (FeedItemActionDetailApi = {}));
export var FeedItemActionLogsOrderApi;
(function (FeedItemActionLogsOrderApi) {
    FeedItemActionLogsOrderApi["ID_DESC"] = "id_desc";
})(FeedItemActionLogsOrderApi || (FeedItemActionLogsOrderApi = {}));
export var FeedAuxiliaryReferenceTypeApi;
(function (FeedAuxiliaryReferenceTypeApi) {
    FeedAuxiliaryReferenceTypeApi["PROJECT"] = "project";
})(FeedAuxiliaryReferenceTypeApi || (FeedAuxiliaryReferenceTypeApi = {}));
